  // 添加数字转人民币大写
  export default function(number) {
    let num = Number(number) || 0;
    if (num === 0) return "零元整";
    const CN_NUM = ["零","壹","贰","叁","肆","伍","陆","柒","捌","玖"];
    const CN_UNIT = ["","拾","佰","仟"];
    const CN_SECTION = ["","万","亿","兆"];
    const CN_DEC_UNIT = ["角","分"];

    let integer = Math.floor(Math.abs(num));
    let decimals = Math.round((Math.abs(num) - integer) * 100);

    let intStr = "";
    if (integer === 0) {
        intStr = "零元";
    } else {
        let sectionPos = 0;
        while (integer > 0) {
        let section = integer % 10000;
        if (section !== 0) {
            let sectionStr = "";
            let unitPos = 0;
            let zero = true;
            while (section > 0) {
            const v = section % 10;
            if (v === 0) {
                if (!zero) {
                sectionStr = CN_NUM[0] + sectionStr;
                zero = true;
                }
            } else {
                sectionStr = CN_NUM[v] + CN_UNIT[unitPos] + sectionStr;
                zero = false;
            }
            unitPos++;
            section = Math.floor(section / 10);
            }
            intStr = sectionStr + CN_SECTION[sectionPos] + intStr;
        } else {
            if (intStr && !intStr.startsWith(CN_NUM[0])) {
            intStr = CN_NUM[0] + intStr;
            }
        }
        integer = Math.floor(integer / 10000);
        sectionPos++;
        }
        intStr += "元";
    }

    if (decimals === 0) {
        intStr += "整";
    } else {
        const jiao = Math.floor(decimals / 10);
        const fen = decimals % 10;
        if (jiao > 0) intStr += CN_NUM[jiao] + CN_DEC_UNIT[0];
        if (fen > 0) intStr += CN_NUM[fen] + CN_DEC_UNIT[1];
    }
    return (num < 0 ? "负" : "") + intStr;
  }

